import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
import { pluginFactory } from '@atlaskit/editor-common/utils';
import { pluginKey } from './plugin-key';
var reducer = function reducer(pluginState, action) {
  if (action.name === 'UPDATE') {
    var updated = false;
    var updatedState = pluginState.map(function (oldTableState) {
      var replace = oldTableState.pos === action.state.pos;
      if (replace) {
        updated = true;
      }
      return replace ? action.state : oldTableState;
    });
    if (!updated) {
      // new, add it
      updatedState.push(action.state);
    }
    return updatedState;
  } else if (action.name === 'REMOVE') {
    return pluginState.filter(function (rowState) {
      return rowState.pos !== action.pos;
    });
  }
  return pluginState;
};
var _pluginFactory = pluginFactory(pluginKey, reducer, {
    mapping: function mapping(tr, pluginState) {
      if (tr.docChanged) {
        return pluginState.map(function (rowInfo) {
          var remapped = tr.mapping.mapResult(rowInfo.pos);
          return remapped ? _objectSpread(_objectSpread({}, rowInfo), {}, {
            pos: remapped.pos
          }) : undefined;
        }).filter(function (f) {
          return f !== undefined;
        });
      }
      return pluginState;
    }
  }),
  createPluginState = _pluginFactory.createPluginState,
  createCommand = _pluginFactory.createCommand;
export { createPluginState, createCommand };